import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import EditForm from './forms/EditForm';
import {
    fetchLabelTypes,
    updateLabel
} from './thunks';

class LabelEditContent extends Component {

    componentWillMount() {
        this.props.fetchLabelTypes();
    }

    handleEditLabelSubmit(formProps) {
        this.props.updateLabel(formProps);
    }

    render() {
        return (
            this.props.loading !== true &&
            <EditForm
                label={this.props.label}
                labelTypes={this.props.labelTypes}
                initialValues={this.props.initialValues}
                handleFormSubmit={this.handleEditLabelSubmit.bind(this)}
                classes={this.props.classes}
                loading={this.props.loading}
            />
        )
    }
}
const mapStateToProps = (state, props) => ({
    initialValues: {
        id: state.labels.label.id,
        display_name: state.labels.label.display_name,
        label_type_id: state.labels.label.label_type_id,
    },
    label: state.labels.label,
    labelTypes: state.labels.labelTypes,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchLabelTypes,
    updateLabel
})(withStyles(styles)(LabelEditContent));



// WEBPACK FOOTER //
// ./src/containers/labels/LabelEditContent.jsx